export default __webpack_public_path__ + "static/media/menu-3.5130535c.PNG";